// extracted by mini-css-extract-plugin
export default {"canvas":"style_canvas__UCx5+","appear":"style_appear__xF590"};